import { TDashboardStoreState } from './types';

export function getRegionStatistic(state: TDashboardStoreState) {
  return state.regionStatistic;
}

export function getTopCountryPartners(state: TDashboardStoreState) {
  return state.topCountryPartners;
}

export function getTopEffectiveRegions(state: TDashboardStoreState) {
  return state.topEffectiveRegions;
}

export function getTopEffectiveRegionsRating(state: TDashboardStoreState) {
  return state.topEffectiveRegionsRating;
}

export function getEventsCountByTypes(state: TDashboardStoreState) {
  return state.eventsCountByTypes;
}

export function getAgreementsCountByTypes(state: TDashboardStoreState) {
  return state.agreementsCountByTypes;
}

export function getEventTypes(state: TDashboardStoreState) {
  return state.eventTypes;
}

export function getEventVedTypes(state: TDashboardStoreState) {
  return state.eventVedTypes;
}

export function getEventStatuses(state: TDashboardStoreState) {
  return state.eventStatuses;
}

export function getPlannedEvents(state: TDashboardStoreState) {
  return state.plannedEvents;
}
